import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityStatusForm from '../../../components/forms/ActivityStatusForm';
import { useCreateActivityStatus } from '../../../hooks/useActivityStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityStatusDTO } from '../../../services/apiClient';

const ActivityStatusCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateActivityStatus();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Statuses', href: '/admin/activitystatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ActivityStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/activitystatuses');
    } catch (error) {
      console.error('Error creating ActivityStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitystatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivityStatus.Edit"
    >
        <ActivityStatusForm
          initialValues={{} as ActivityStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/activitystatuses')}
        />
    </AdminLayout>
  );
};

export default ActivityStatusCreate;
